import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchSurveys, fetchSurveyResponseCount } from '../utils/serverComm';
import { toast } from 'react-toastify';
import { ChevronRight, Plus } from 'lucide-react';
import './SurveyList.css';

function SurveyList({ onCreateSurvey }) {
  const [surveys, setSurveys] = useState([]);
  const [responseCounts, setResponseCounts] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadSurveys = async () => {
      try {
        setIsLoading(true);
        const userSurveys = await fetchSurveys();
        console.log('Fetched surveys:', userSurveys);
        setSurveys(userSurveys);
        
        // Fetch response counts for each survey
        const counts = {};
        for (const survey of userSurveys) {
          const count = await fetchSurveyResponseCount(survey.surveyId);
          counts[survey.surveyId] = count;
        }
        setResponseCounts(counts);
      } catch (error) {
        console.error('Failed to load surveys:', error);
        toast.error('Failed to load surveys');
      } finally {
        setIsLoading(false);
      }
    };
    loadSurveys();
  }, []);

  if (isLoading) {
    return <div className="text-gray-600">Loading surveys...</div>;
  }

  if (surveys.length === 0) {
    return (
      <div className="text-center">
        <p className="text-gray-500 mb-6">
          No surveys yet. Create your first survey!
        </p>
        <button
          onClick={onCreateSurvey}
          className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors mx-auto"
        >
          <Plus className="w-5 h-5" />
          Create New Survey
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-800">Your Surveys</h2>
        <button
          onClick={onCreateSurvey}
          className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
        >
          <Plus className="w-5 h-5" />
          New Survey
        </button>
      </div>

      <div className="space-y-4">
        {surveys.map((survey) => (
          <div
            key={survey.surveyId}
            onClick={() => navigate(`/survey/${survey.surveyId}`)}
            className="flex items-center justify-between p-4 bg-white rounded-lg border border-gray-200 hover:border-blue-500 cursor-pointer group"
          >
            <div className="flex-1">
              <h3 className="text-lg font-medium text-gray-900 group-hover:text-blue-600">
                {survey.title || 'Untitled Survey'}
              </h3>
              <p className="text-sm text-gray-500">
                {survey.questions?.length || 0} questions
              </p>
              <p className="text-sm text-gray-500">
                {responseCounts[survey.surveyId] || 0} responses
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-blue-500" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default SurveyList; 